import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapProjects } from "../Types/Project/ProjectInterface";
import { getServiceProjects } from "../../Api/layoutServices";

// fetch service projects
export const fetchServiceProjects = createAsyncThunk(
    'fetchServiceProjects',
    async (service_id: number, { rejectWithValue }) => {
        try {
            // api
            const response = await getServiceProjects(service_id);
            if (response.status) {
                return mapProjects(response.body);
            } else {
                // If the API returns a failure status, return the error message
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            // Handle the case where the API call itself throws an error
            return rejectWithValue('Failed to fetch projets');
        }
    }
);